function initDefaults ({ v }) {
  let option = {
    color: [],
    grid: {
      left: '5%',
      top: '0%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: ['普通话', '广东话', '东北话', '湖南话', '湖北话', '西安话', '山东话'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(202, 55, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(28, 41, 239, 1)' // 100% 处的颜色
        }]
      },
      data: [1, 2, 3, 4, 5, 6, 7],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        normal: {
          position: 'insideRight',
          show: true,
          textBorderColor: '#333',
          textBorderWidth: 2,
          color: 'rgba(255,255,255,1)'
        }
      }
    }]
  }
  return option
}

export function PopularFilmRelevisionRankingEchartOp ({ v, data }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let options = initDefaults({ v })
  options.series[0].color = {
    type: 'linear',
    x: 1,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0, color: 'rgba(202, 55, 255, 1)' // 0% 处的颜色
    }, {
      offset: 1, color: 'rgba(28, 41, 239, 1)' // 100% 处的颜色
    }]
  }
  options.yAxis[0].data = [
    ...data.yAxisName
  ]
  options.series[0].data = [...data.seriesData]
  return options
}
export function TopSearchRankingEchartOp ({ v, data }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let options = initDefaults({ v })
  options.series[0].color = {
    type: 'linear',
    x: 1,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0, color: 'rgba(45, 185, 232, 1)' // 0% 处的颜色
    }, {
      offset: 1, color: 'rgba(28, 79, 239, 1)' // 100% 处的颜色
    }]
  }
  options.yAxis[0].data = [
    ...data.yAxisName
  ]
  options.yAxis[0].axisLabel = {
    width: 70,
    overflow: 'truncate',
    ellipsis: '...',
    ...options.yAxis[0].axisLabel
  }
  options.series[0].data = [...data.seriesData]
  return options
}
export function PopularAppRankingEchartOp ({ v, data }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let options = initDefaults({ v })
  options.series[0].color = {
    type: 'linear',
    x: 1,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0, color: 'rgba(246, 163, 84, 1)' // 0% 处的颜色
    }, {
      offset: 1, color: 'rgba(239, 28, 28, 1)' // 100% 处的颜色
    }]
  }
  options.yAxis[0].data = [
    ...data.yAxisName
  ]
  options.series[0].data = [...data.seriesData]
  return options
}

export function ContentPlaybackDurationEchartOp ({ v }) {
  let option = {
    grid: {
      left: '-5%',
      top: '0%',
      right: '0%',
      bottom: '10%',
      containLabel: false
    },
    xAxis: [{
      type: 'category',
      data: ['全频道', '电视剧', '电影', '动漫', '儿童'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      nameTextStyle: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    yAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(64, 236, 196, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(55, 179, 240, 1)' // 100% 处的颜色
        }]
      },
      data: [347281, 199197, 31400, 29344, 26818],
      barWidth: v.fontSizeRem(1.25),
      label: {
        normal: {
          show: false
        }
      }
    }]
  }

  return option
}
export function ContentConversionEchartOp ({ v }) {
  let option = {
    color: ['rgba(64, 236, 196, 1)', 'rgba(55, 179, 240, 1)', 'rgba(54, 207, 220, 1)'],
    series: [
      {
        type: 'sankey',
        layout: 'none',
        focusNodeAdjacency: 'allEdges',
        label: {
          color: 'rgba(255, 255, 255, 1)'
        },
        right: '5%',
        left: '2%',
        data: [
          {
            'name': '精选'
          },
          {
            'name': '教育'
          },
          {
            'name': 'VIP'
          },
          {
            'name': '剧集'
          },
          {
            'name': '电影'
          },
          {
            'name': '综艺'
          },
          {
            'name': '购物'
          },
          {
            'name': '我的'
          },
          {
            'name': '应用'
          },
          {
            'name': '体育'
          },
          {
            'name': '游戏'
          },
          {
            'name': '少儿'
          },
          {
            'name': '消息/弹窗/屏保'
          },
          {
            'name': '我的任务'
          },
          {
            'name': '兑换商城'
          },
          {
            'name': '播放记录'
          },
          {
            'name': '轮播频道'
          },
          {
            'name': '影视专题页'
          },
          {
            'name': '教育专题页'
          },
          {
            'name': '体育专题页'
          },
          {
            'name': '我的应用'
          },
          {
            'name': '应用圈'
          },
          {
            'name': '历史收藏'
          },
          {
            'name': '搜索'
          },
          {
            'name': '列表页'
          },
          {
            'name': '影视详情页'
          },
          {
            'name': '教育详情页'
          },
          {
            'name': '体育详情页'
          },
          {
            'name': '购物详情页'
          },
          {
            'name': '应用详情页'
          },
          {
            'name': '产品包页'
          }
        ],
        links: [
          {
            'source': '精选',
            'target': '轮播频道',
            'value': 1.2
          },
          {
            'source': '精选',
            'target': '影视专题页',
            'value': 1
          },
          {
            'source': '精选',
            'target': '我的应用',
            'value': 1
          },
          {
            'source': '精选',
            'target': '列表页',
            'value': 1
          },
          {
            'source': '精选',
            'target': '历史收藏',
            'value': 1
          },
          {
            'source': '精选',
            'target': '搜索',
            'value': 1
          },
          {
            'source': '教育',
            'target': '教育专题页',
            'value': 1
          },
          {
            'source': '教育',
            'target': '教育详情页',
            'value': 1
          },
          {
            'source': '教育',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '少儿',
            'target': '教育专题页',
            'value': 1
          },
          {
            'source': '少儿',
            'target': '教育详情页',
            'value': 1
          },
          {
            'source': '少儿',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '少儿',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': 'VIP',
            'target': '影视专题页',
            'value': 1
          },
          {
            'source': 'VIP',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': 'VIP',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '剧集',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '剧集',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '剧集',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '电影',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '电影',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '电影',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '综艺',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '综艺',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '综艺',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '电影',
            'target': '列表页',
            'value': 1
          },
          {
            'source': '剧集',
            'target': '列表页',
            'value': 1
          },
          {
            'source': '综艺',
            'target': '列表页',
            'value': 1
          },
          {
            'source': '体育',
            'target': '体育专题页',
            'value': 1
          },
          {
            'source': '体育',
            'target': '体育详情页',
            'value': 1
          },
          {
            'source': '体育',
            'target': '列表页',
            'value': 1
          },
          {
            'source': '体育',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '购物',
            'target': '购物详情页',
            'value': 1
          },
          {
            'source': '应用',
            'target': '应用圈',
            'value': 1
          },
          {
            'source': '应用',
            'target': '我的应用',
            'value': 1
          },
          {
            'source': '应用',
            'target': '搜索',
            'value': 1
          },
          {
            'source': '应用',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '游戏',
            'target': '应用圈',
            'value': 1
          },
          {
            'source': '游戏',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '我的',
            'target': '我的任务',
            'value': 1
          },
          {
            'source': '我的',
            'target': '兑换商城',
            'value': 1
          },
          {
            'source': '兑换商城',
            'target': '购物详情页',
            'value': 1
          },
          {
            'source': '我的',
            'target': '播放记录',
            'value': 1
          },
          {
            'source': '我的',
            'target': '历史收藏',
            'value': 1
          },
          {
            'source': '历史收藏',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '历史收藏',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '列表页',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '列表页',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '列表页',
            'target': '体育详情页',
            'value': 1
          },
          {
            'source': '消息/弹窗/屏保',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '消息/弹窗/屏保',
            'target': '购物详情页',
            'value': 1
          },
          {
            'source': '消息/弹窗/屏保',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '影视专题页',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '教育专题页',
            'target': '教育详情页',
            'value': 1
          },
          {
            'source': '体育专题页',
            'target': '体育详情页',
            'value': 1
          },
          {
            'source': '我的应用',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '应用圈',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '轮播频道',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '轮播频道',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '影视详情页',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '教育详情页',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '体育详情页',
            'target': '产品包页',
            'value': 1
          },
          {
            'source': '搜索',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '搜索',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '播放记录',
            'target': '应用详情页',
            'value': 1
          },
          {
            'source': '播放记录',
            'target': '影视详情页',
            'value': 1
          },
          {
            'source': '播放记录',
            'target': '教育详情页',
            'value': 1
          },
          {
            'source': '播放记录',
            'target': '体育详情页',
            'value': 1
          }
        ]

        // links: [{
        //   source: 'a',
        //   target: 'a1',
        //   value: 5
        // }, {
        //   source: 'a',
        //   target: 'a2',
        //   value: 3
        // }, {
        //   source: 'b',
        //   target: 'b1',
        //   value: 8
        // }, {
        //   source: 'a',
        //   target: 'b1',
        //   value: 3
        // }, {
        //   source: 'b1',
        //   target: 'a1',
        //   value: 1
        // }, {
        //   source: 'b1',
        //   target: 'c',
        //   value: 2
        // }]
      }
    ]
  }

  return option
}
